import { STATIC_URL } from 'constants/data'
import { FC } from 'react'
import Image from 'next/image'

import styles from './btn-open-contents.module.scss'

interface IBtnOpenContents {
  open: () => void
  isOpened?: boolean
}

const imgData = {
  open: {
    src: `${STATIC_URL}/courses/icon_mobile_nav.svg`,
    alt: 'Содержание',
    width: 18,
    height: 18,
  },
  close: {
    src: `${STATIC_URL}/courses/icon_close.svg`,
    alt: 'закрыть содержание',
    width: 19,
    height: 14,
  },
}

const BtnOpenContents: FC<IBtnOpenContents> = ({ open, isOpened }) => {
  return (
    <div className={styles.btn} onClick={open}>
      <Image {...imgData[isOpened ? 'close' : 'open']} />
    </div>
  )
}

export default BtnOpenContents
